import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { Column } from '@miq/catalog';
import { MiqBehaviors } from '@shared/behaviors';
import { getLovValueKey } from '@shared/utils/helpers/lov-datakey-factory';

import { BaseInput } from '../base-input';
import { DataObject } from '@shared/models/data-object.model';

const NO_PRIVACY_CONFIDENTIALITY = '0';

@Component({
  selector: 'miq-select-confidentiality',
  templateUrl: './select-confidentiality.component.html',
  styleUrls: ['./select-confidentiality.component.scss'],
  providers: [{ provide: MiqBehaviors, useExisting: SelectConfidentialityComponent }],
  standalone: false,
})
export class SelectConfidentialityComponent extends BaseInput implements OnInit, OnChanges, OnDestroy {
  @Input() values = [];
  @Input() declare currentValue: string;
  @Input() placeholder = '';
  @Input() lookupCategory: string;
  @Input() panelClass: boolean;
  @Input() capitalized = false;
  @Input() record: DataObject;
  @Input() userConfidentialityLevel: string;
  @Input() recordConfidentialityLevel: string;
  protected _config: Column;
  @Input()
  set config(c: Column) {
    this._config = c;
  }

  @Output() currentValueChange = new EventEmitter<string>();

  @ViewChild(MatSelect, { static: true }) matSelect: MatSelect;

  disabled = false;
  dataKey = 'key';
  isRecordPrivate: boolean;
  noPrivacyConfidentiality = NO_PRIVACY_CONFIDENTIALITY;

  ngOnInit(): void {
    super.ngOnInit();
    this.dataKey = getLovValueKey(this.column);
    this.initPrivacyParameters();
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    const { currentValue } = changes;
    this.initConfidentialityLevelAllowances();
    if (!!currentValue && !currentValue.firstChange) {
      this.fc.setValue(this.currentValue);
      this.initPrivacyParameters();
    }
  }

  private initPrivacyParameters() {
    if (this.record == null) {
      return;
    }
    const accessControl = this.record.access_control || {};
    this.isRecordPrivate = accessControl.private_data_f;
    this.warning = this.currentValue === this.noPrivacyConfidentiality && this.isRecordPrivate;
  }

  private initConfidentialityLevelAllowances() {
    this.disabled = this.recordConfidentialityLevel > this.userConfidentialityLevel;

    if (!this.disabled && this.values) {
      this.values = this.values.map(confidentiality => {
        return {
          ...confidentiality,
          disabled:
            this.userConfidentialityLevel < this.currentValue
              ? true
              : confidentiality.key > this.userConfidentialityLevel,
        };
      });
    }
  }

  public onChange(val) {
    this.currentValue = val;
    this.currentValueChange.emit(this.valueSetter ? this.valueSetter(val) : val);
  }

  public focus() {
    this.matSelect.focus();
  }

  ngOnDestroy() {
    /* label translation purpose added */
    this.matSelect = null;
  }
}
